import { DateTime } from "luxon";
import { RabbitNumber } from "types/ShiftTracker";

export const dcrHeadLabelCondition = (label: any, week: number, year: number) =>
  `${year}-${String(week).length < 2 ? `0${week}` : week}` > "2026-23" && label === "DCR";

export const getDateNumber = (type: string | undefined, value: string) => {
  switch (type) {
    case "month":
      return value.split("-")[1];
    case "week":
      return value.split("-W")[1];
    default:
      return value;
  }
};

export const sortByRabbit = (a: RabbitNumber, b: RabbitNumber) => {
  let strA = a.serial_number.match(/\d+/);
  let strB = b.serial_number.match(/\d+/);
  return strA && strB ? parseInt(strA[0]) - parseInt(strB[0]) : 0;
};

export const getNextDay = (dayString: string, amount: number) => {
  const dt = DateTime.fromFormat(dayString, "yyyy-MM-dd");
  return dt.plus({ days: amount }).toFormat("yyyy-MM-dd");
};

export const getPreviousDay = (dayString: string, amount: number) => {
  const dt = DateTime.fromFormat(dayString, "yyyy-MM-dd");
  return dt.minus({ days: amount }).toFormat("yyyy-MM-dd");
};

export const getNextWeek = (weekString: string, amount: number) => {
  const dt = DateTime.fromFormat(weekString, "kkkk-'W'WW");
  return dt.plus({ weeks: amount }).toFormat("kkkk-'W'WW");
};

export const getPeviousWeek = (weekString: string, amount: number) => {
  const dt = DateTime.fromFormat(weekString, "kkkk-'W'WW");
  return dt.minus({ weeks: amount }).toFormat("kkkk-'W'WW");
};

export const getNextMonthNew = (monthString: string, amount: number) => {
  const dt = DateTime.fromFormat(monthString, "yyyy-MM");
  return dt.plus({ months: amount }).toFormat("yyyy-MM");
};

export const getPeviousMonthNew = (monthString: string, amount: number) => {
  const dt = DateTime.fromFormat(monthString, "yyyy-MM");
  return dt.minus({ months: amount }).toFormat("yyyy-MM");
};

export const getPreviousMonth = (month: number, year: number, amount: number) => {
  const dt = DateTime.fromObject({ year: Number(year), month: Number(month) });
  const getPreviousMonth = dt.minus({ months: amount });
  return getPreviousMonth.toFormat("yyyy-L");
};
